export const SOURCE_FILE_MUTATION_ERROR_REASON = {
  422: 'fileAssigned',
  409: 'optimisticLocking',
  'UNKNOWN': null,
};
